export default "__VITE_ASSET__ea7326ff__"